/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Internal API
 * OpenAPI spec version: v1
 */
import {
  queryOptions as queryOptionsBuilder,
  useMutation,
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query';

import type {
  DocusignConfigurationStatus
} from '../../model';

import { customInstance } from '../../../mutator.ts';
import type { ErrorType } from '../../../mutator.ts';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getGetConsentUriUrl = () => {




  return `/api/Docusign/GetConsentUri`
}

export const getConsentUri = async ( options?: Parameters<typeof customInstance>[1]): Promise<string> => {

  return customInstance<string>(getGetConsentUriUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetConsentUriQueryKey = () => {
    return [
    `/api/Docusign/GetConsentUri`
    ] as const;
    }


export const getGetConsentUriQueryOptions = <TData = Awaited<ReturnType<typeof getConsentUri>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getConsentUri>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetConsentUriQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getConsentUri>>> = ({ signal }) => getConsentUri({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getConsentUri>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetConsentUriQueryResult = NonNullable<Awaited<ReturnType<typeof getConsentUri>>>
export type GetConsentUriQueryError = ErrorType<unknown>


export function useGetConsentUri<TData = Awaited<ReturnType<typeof getConsentUri>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getConsentUri>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getConsentUri>>,
          TError,
          Awaited<ReturnType<typeof getConsentUri>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetConsentUri<TData = Awaited<ReturnType<typeof getConsentUri>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getConsentUri>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getConsentUri>>,
          TError,
          Awaited<ReturnType<typeof getConsentUri>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetConsentUri<TData = Awaited<ReturnType<typeof getConsentUri>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getConsentUri>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetConsentUri<TData = Awaited<ReturnType<typeof getConsentUri>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getConsentUri>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetConsentUriQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetConsentUriSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getConsentUri>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getConsentUri>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetConsentUriQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getConsentUri>>> = ({ signal }) => getConsentUri({ signal, ...requestOptions });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getConsentUri>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetConsentUriSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getConsentUri>>>
export type GetConsentUriSuspenseQueryError = ErrorType<unknown>


export function useGetConsentUriSuspense<TData = Awaited<ReturnType<typeof getConsentUri>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getConsentUri>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetConsentUriSuspense<TData = Awaited<ReturnType<typeof getConsentUri>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getConsentUri>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetConsentUriSuspense<TData = Awaited<ReturnType<typeof getConsentUri>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getConsentUri>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetConsentUriSuspense<TData = Awaited<ReturnType<typeof getConsentUri>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getConsentUri>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetConsentUriSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetRSAKeyOrGenerateNewUrl = () => {




  return `/api/Docusign/GetRSAKeyOrGenerateNew`
}

export const getRSAKeyOrGenerateNew = async ( options?: Parameters<typeof customInstance>[1]): Promise<string> => {

  return customInstance<string>(getGetRSAKeyOrGenerateNewUrl(),
  {
    ...options,
    method: 'POST'


  }
);}





export const getGetRSAKeyOrGenerateNewMutationKey = () => ['getRSAKeyOrGenerateNew'] as const;

export const getGetRSAKeyOrGenerateNewMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getRSAKeyOrGenerateNew>>, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof getRSAKeyOrGenerateNew>>, TError,void, TContext> => {

const mutationKey = getGetRSAKeyOrGenerateNewMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getRSAKeyOrGenerateNew>>, void> = () => {


          return  getRSAKeyOrGenerateNew(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GetRSAKeyOrGenerateNewMutationResult = NonNullable<Awaited<ReturnType<typeof getRSAKeyOrGenerateNew>>>

    export type GetRSAKeyOrGenerateNewMutationError = ErrorType<unknown>


    export const useGetRSAKeyOrGenerateNew = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getRSAKeyOrGenerateNew>>, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getRSAKeyOrGenerateNew>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getGetRSAKeyOrGenerateNewMutationOptions(options), queryClient);
    }
    export const getGetDocusignConfigurationStatusUrl = () => {




  return `/api/Docusign/GetDocusignConfigurationStatus`
}

export const getDocusignConfigurationStatus = async ( options?: Parameters<typeof customInstance>[1]): Promise<DocusignConfigurationStatus> => {

  return customInstance<DocusignConfigurationStatus>(getGetDocusignConfigurationStatusUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetDocusignConfigurationStatusQueryKey = () => {
    return [
    `/api/Docusign/GetDocusignConfigurationStatus`
    ] as const;
    }


export const getGetDocusignConfigurationStatusQueryOptions = <TData = Awaited<ReturnType<typeof getDocusignConfigurationStatus>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDocusignConfigurationStatus>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDocusignConfigurationStatusQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDocusignConfigurationStatus>>> = ({ signal }) => getDocusignConfigurationStatus({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDocusignConfigurationStatus>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetDocusignConfigurationStatusQueryResult = NonNullable<Awaited<ReturnType<typeof getDocusignConfigurationStatus>>>
export type GetDocusignConfigurationStatusQueryError = ErrorType<unknown>


export function useGetDocusignConfigurationStatus<TData = Awaited<ReturnType<typeof getDocusignConfigurationStatus>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDocusignConfigurationStatus>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDocusignConfigurationStatus>>,
          TError,
          Awaited<ReturnType<typeof getDocusignConfigurationStatus>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDocusignConfigurationStatus<TData = Awaited<ReturnType<typeof getDocusignConfigurationStatus>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDocusignConfigurationStatus>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDocusignConfigurationStatus>>,
          TError,
          Awaited<ReturnType<typeof getDocusignConfigurationStatus>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDocusignConfigurationStatus<TData = Awaited<ReturnType<typeof getDocusignConfigurationStatus>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDocusignConfigurationStatus>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetDocusignConfigurationStatus<TData = Awaited<ReturnType<typeof getDocusignConfigurationStatus>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDocusignConfigurationStatus>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetDocusignConfigurationStatusQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetDocusignConfigurationStatusSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getDocusignConfigurationStatus>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getDocusignConfigurationStatus>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDocusignConfigurationStatusQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDocusignConfigurationStatus>>> = ({ signal }) => getDocusignConfigurationStatus({ signal, ...requestOptions });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getDocusignConfigurationStatus>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetDocusignConfigurationStatusSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getDocusignConfigurationStatus>>>
export type GetDocusignConfigurationStatusSuspenseQueryError = ErrorType<unknown>


export function useGetDocusignConfigurationStatusSuspense<TData = Awaited<ReturnType<typeof getDocusignConfigurationStatus>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getDocusignConfigurationStatus>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDocusignConfigurationStatusSuspense<TData = Awaited<ReturnType<typeof getDocusignConfigurationStatus>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getDocusignConfigurationStatus>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDocusignConfigurationStatusSuspense<TData = Awaited<ReturnType<typeof getDocusignConfigurationStatus>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getDocusignConfigurationStatus>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetDocusignConfigurationStatusSuspense<TData = Awaited<ReturnType<typeof getDocusignConfigurationStatus>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getDocusignConfigurationStatus>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetDocusignConfigurationStatusSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getUpdateConsentedIntegrationUrl = () => {




  return `/api/Docusign/UpdateConsentedIntegration`
}

export const updateConsentedIntegration = async ( options?: Parameters<typeof customInstance>[1]): Promise<void> => {

  return customInstance<void>(getUpdateConsentedIntegrationUrl(),
  {
    ...options,
    method: 'POST'


  }
);}





export const getUpdateConsentedIntegrationMutationKey = () => ['updateConsentedIntegration'] as const;

export const getUpdateConsentedIntegrationMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateConsentedIntegration>>, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateConsentedIntegration>>, TError,void, TContext> => {

const mutationKey = getUpdateConsentedIntegrationMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateConsentedIntegration>>, void> = () => {


          return  updateConsentedIntegration(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateConsentedIntegrationMutationResult = NonNullable<Awaited<ReturnType<typeof updateConsentedIntegration>>>

    export type UpdateConsentedIntegrationMutationError = ErrorType<unknown>


    export const useUpdateConsentedIntegration = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateConsentedIntegration>>, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateConsentedIntegration>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getUpdateConsentedIntegrationMutationOptions(options), queryClient);
    }
    export const getGetRedirectUrlUrl = () => {




  return `/api/Docusign/GetRedirectUrl`
}

export const getRedirectUrl = async ( options?: Parameters<typeof customInstance>[1]): Promise<string> => {

  return customInstance<string>(getGetRedirectUrlUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetRedirectUrlQueryKey = () => {
    return [
    `/api/Docusign/GetRedirectUrl`
    ] as const;
    }


export const getGetRedirectUrlQueryOptions = <TData = Awaited<ReturnType<typeof getRedirectUrl>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRedirectUrl>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetRedirectUrlQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRedirectUrl>>> = ({ signal }) => getRedirectUrl({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getRedirectUrl>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetRedirectUrlQueryResult = NonNullable<Awaited<ReturnType<typeof getRedirectUrl>>>
export type GetRedirectUrlQueryError = ErrorType<unknown>


export function useGetRedirectUrl<TData = Awaited<ReturnType<typeof getRedirectUrl>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRedirectUrl>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRedirectUrl>>,
          TError,
          Awaited<ReturnType<typeof getRedirectUrl>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRedirectUrl<TData = Awaited<ReturnType<typeof getRedirectUrl>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRedirectUrl>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRedirectUrl>>,
          TError,
          Awaited<ReturnType<typeof getRedirectUrl>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRedirectUrl<TData = Awaited<ReturnType<typeof getRedirectUrl>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRedirectUrl>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetRedirectUrl<TData = Awaited<ReturnType<typeof getRedirectUrl>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRedirectUrl>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetRedirectUrlQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetRedirectUrlSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getRedirectUrl>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getRedirectUrl>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetRedirectUrlQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRedirectUrl>>> = ({ signal }) => getRedirectUrl({ signal, ...requestOptions });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getRedirectUrl>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetRedirectUrlSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getRedirectUrl>>>
export type GetRedirectUrlSuspenseQueryError = ErrorType<unknown>


export function useGetRedirectUrlSuspense<TData = Awaited<ReturnType<typeof getRedirectUrl>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getRedirectUrl>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRedirectUrlSuspense<TData = Awaited<ReturnType<typeof getRedirectUrl>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getRedirectUrl>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRedirectUrlSuspense<TData = Awaited<ReturnType<typeof getRedirectUrl>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getRedirectUrl>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetRedirectUrlSuspense<TData = Awaited<ReturnType<typeof getRedirectUrl>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getRedirectUrl>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetRedirectUrlSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






